<template>
  <b-modal
    id="modal-documents"
    :ok-title="$t('Save')"
    :cancel-title="$t('Abort')"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    hideHeaderClose
    @ok.prevent="saveData"
    @cancel="resetModal"
    @show="showModal"
    @hidden="modalHidden"
    size="lg"
    centered
  >
    <b-overlay :show="show" rounded="sm">
      <b-row>
        <b-col cols="12" class="modalTitle">
          <h2 class="font-weight-bolder" v-if="!editTitle">
            {{ pinpoint.label }}
            <b-button
              v-if="pinpoint.type.editable"
              class="btn-icon rounded-circle"
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                @click="editTitle = true"
                variant="flat-primary"
              />
            </b-button>
          </h2>
          <b-form-input
            v-if="editTitle"
            type="text"
            v-model="pinpoint.label"
            maxlength="25"
            autofocus
          />
        </b-col>
      </b-row>
      <div>
        <b-form
          ref="form"
          :style="{ height: trHeight }"
          class="repeater-form"
          @submit.prevent="addItem"
        >
          <b-row
            v-for="(item, index) in document_list"
            :id="item.id"
            :key="item.id"
            ref="row"
          >
            <b-col md="4">
              <b-form-group
                :label="$t('pin_point.document_url')"
                :label-for="`documents_url_${item.id}`"
              >
                <b-form-file
                  :id="`documents_file_${item.id}`"
                  v-model="item.file"
                  :placeholder="$t('any_file_select')"
                  @input="save_file(item.file, item.id)"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('pin_point.Title')"
                :label-for="`documents_label_${item.id}`"
              >
                <b-form-input
                  :id="`documents_label_${item.id}`"
                  type="text"
                  v-model="item.label"
                  :placeholder="$t('pin_point.document_title')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="2" md="2" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeItem(index)"
              >
                <feather-icon icon="XIcon" class="mr-25" />
              </b-button>
            </b-col>
            <b-col md="12" class="mb-2" v-if="item.file_url != ''">
              <a
                :id="`documents_link_${item.id}`"
                :href="item.file_url"
                target="_blank"
              >
                <feather-icon icon="FileIcon" /> {{ item.file_name }}
              </a>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>{{ $t("pin_point.add") }}</span>
      </b-button>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-row>
        <b-col cols="12" class="pin_hide">
          <icon-selector v-if="pinpoint.type.editable" v-model="icon">
          </icon-selector>
          <footer-pin-point v-model="hide_pinpont"></footer-pin-point>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BModal,
  BOverlay,
  BFormFile,
} from "bootstrap-vue";

import { heightTransition } from "@core/mixins/ui/transition";
import flatPickr from "vue-flatpickr-component";
import "@core/scss/vue/libs/vue-flatpicker.scss";
import Ripple from "vue-ripple-directive";
import FooterPinPoint from "./footer";
import IconSelector from "./icon-selector";

import { ValidationProvider, ValidationObserver } from "vee-validate";

import { getPinpoint, updatePinpoint, uploadPinpointFile } from "@api/pinpoint";

export default {
  props: ["pinpoint"],
  name: "pin-point-documents",
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BModal,
    BOverlay,
    FooterPinPoint,
    flatPickr,
    IconSelector,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      original_pin: null,
      document_list: [
        {
          id: 1,
          label: "",
          file_url: "",
          file_name: "",
          file: null,
        },
      ],
      nextItemId: 2,
      hide_pinpont: !this.pinpoint.active,
      show: false,
      editTitle: false,
      icon: this.pinpoint.icon,
    };
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    showModal() {
      const $this = this;
      getPinpoint($this.pinpoint.id)
        .then((data) => {
          $this.original_pin = data;
          $this.icon = data.icon;
          if ($this.original_pin.fields.document_list.length > 0) {
            $this.document_list = [];
            for (
              let i = 0;
              i < $this.original_pin.fields.document_list.length;
              i++
            ) {
              const element = $this.original_pin.fields.document_list[i];
              $this.nextItemId++;
              $this.document_list.push({
                id: i + 1,
                label: element.label,
                file_url: element.document,
                file_name: element.label == "" ? "LINK" : element.label,
                file: null,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      const $this = this;
      this.show = true;
      let formData = new FormData();
      formData.append("label", $this.pinpoint.label);
      if ($this.document_list.length == 0) {
        formData.append(`document_list`, []);
      } else {
        for (let i = 0; i < $this.document_list.length; i++) {
          formData.append(
            `document_list[${i}][label]`,
            $this.document_list[i].label
          );
          formData.append(
            `document_list[${i}][document]`,
            $this.document_list[i].file_url
          );
        }
      }
      formData.append("icon", $this.icon);
      formData.append("active", $this.hide_pinpont ? 0 : 1);
      updatePinpoint($this.pinpoint.id, formData)
        .then((data) => {
          this.$emit("onSave");
          this.$bvModal.hide("modal-documents");
          this.show = false;
        })
        .catch((error) => {
          console.log(error);
          this.show = false;
        });
    },
    save_file(file, id) {
      const $this = this;
      $this.show = true;
      let formData = new FormData();
      formData.append("file", file);
      uploadPinpointFile($this.pinpoint.id, formData)
        .then((data) => {
          $this.document_list.forEach((element) => {
            if (element.id == id) {
              element.file_name = file.name;
              element.file = file;
              element.file_url = data;
              $this.show = false;
              return;
            }
          });
        })
        .catch((error) => {
          console.log(error);
          $this.show = false;
        });
    },
    resetModal() {
      this.$bvModal.hide("modal-documents");
      this.fields = { ...this.pinpoint.fields };
      this.icon = this.original_pin.icon;
      this.pinpoint.label = this.original_pin.label;
      this.hide_pinpont = !this.pinpoint.active;
    },
    addItem() {
      this.document_list.push({
        id: this.nextItemId++,
        label: "",
        file_name: "",
        file: null,
        file_url: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.document_list.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        //per evitare che lo esegua se non esiste
        if (typeof this.$refs.form !== "undefined") {
          this.trSetHeight(this.$refs.form.scrollHeight);
        }
      });
    },
    modalHidden() {
      this.editTitle = false;
    },
  },
};
</script>

<style>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
